import { useState, useEffect, useCallback } from "react";

const useMousePosition = () => {
  const [mousePosition, setMousePosition] = useState(0);
  const [currentPosition, setCurrentPosition] = useState(0);

  const updateMousePosition = useCallback(
    (e) => {
      if (e.clientY) {
        setMousePosition(e.clientY);
      }
      setCurrentPosition(window.pageYOffset + mousePosition);
    },
    [mousePosition],
  );

  useEffect(() => {
    window.addEventListener("mousemove", updateMousePosition);
    window.addEventListener("scroll", updateMousePosition);

    return () => {
      window.removeEventListener("mousemove", updateMousePosition);
      window.removeEventListener("scroll", updateMousePosition);
    };
  }, [updateMousePosition]);

  return currentPosition;
};

export default useMousePosition;
